<footer class="footer">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_1fr] gap-10 max-w-[1280px] mx-auto py-14 px-6 md:px-10">

    <!-- Brand -->
    <div>
      <a href="#" class="footer-brand-link flex items-center gap-3">
        <img
          src="assets/icons/svg/caminhao_logo.svg"
          alt=""
          aria-hidden="true"
          class="footer-brand-logo"
        />
        <span class="footer-brand-text">Plataforma<br/><strong>de Fretes</strong></span>
      </a>
      <p class="footer-desc">{{ 'footer.brand_description' | translate }}</p>
      <a href="#" class="btn-contact inline-flex items-center gap-2">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.56 3.34 2 2 0 0 1 3.54 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.54a16 16 0 0 0 5.55 5.55l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z"/>
        </svg>
        {{ 'footer.contact_button' | translate }}
      </a>
    </div>

    <!-- Clients -->
    <div class="footer-col">
      <h4>{{ 'footer.clients_section' | translate }}</h4>
      <ul class="flex flex-col gap-3 list-none p-0 m-0">
        <li><a href="#">{{ 'footer.shippers' | translate }}</a></li>
        <li><a href="#">{{ 'footer.carriers' | translate }}</a></li>
      </ul>
    </div>

    <!-- Useful links -->
    <div class="footer-col">
      <h4>{{ 'footer.useful_links_section' | translate }}</h4>
      <ul class="flex flex-col gap-3 list-none p-0 m-0">
        <li><a href="https://www.senior.com.br/politica-de-privacidade" target="_blank">{{ 'footer.privacy_policy' | translate }}</a></li>
        <li><a href="https://www.senior.com.br/politica-de-seguranca-da-informacao" target="_blank">{{ 'footer.security_policy' | translate }}</a></li>
        <li><a href="https://www.senior.com.br/politica-de-privacidade" target="_blank">{{ 'footer.terms_of_use' | translate }}</a></li>
      </ul>
    </div>

    <!-- Social -->
    <div class="footer-col">
      <h4>{{ 'footer.social_section' | translate }}</h4>
      <div class="flex gap-2 flex-wrap">
        <a href="#" class="social-icon" [appTippy]="TOOLTIP_KEYS.SOCIAL_TWITTER | translate" [tippyOptions]="{ placement: 'top' }">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.631 5.905-5.631Zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </a>
        <a href="#" class="social-icon" [appTippy]="TOOLTIP_KEYS.SOCIAL_LINKEDIN | translate" [tippyOptions]="{ placement: 'top' }">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
            <circle cx="4" cy="4" r="2"/>
          </svg>
        </a>
        <a href="#" class="social-icon" [appTippy]="TOOLTIP_KEYS.SOCIAL_FACEBOOK | translate" [tippyOptions]="{ placement: 'top' }">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
          </svg>
        </a>
        <a href="#" class="social-icon" [appTippy]="TOOLTIP_KEYS.SOCIAL_INSTAGRAM | translate" [tippyOptions]="{ placement: 'top' }">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
          </svg>
        </a>
      </div>
    </div>

  </div>

  <div class="footer-bottom">
    <div class="flex items-center justify-between gap-2 flex-wrap max-w-[1280px] mx-auto py-4 px-6 md:px-10 max-md:flex-col max-md:text-center">
      <span class="footer-copy">{{ 'footer.copyright' | translate }}</span>
      <span class="footer-copy">{{ 'footer.rights_reserved' | translate }}</span>
    </div>
  </div>
</footer>
